import type { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import type {
  Lci3DimensionTableData,
  CustomFields,
} from '@features/lci-report';
import type { Slide } from '@features/powerpoint';
import type { RslReport } from '@features/campaigns/subdomains/rsl';
import { DEFAULT_SLIDE_MASTER } from '@features/powerpoint';
import { renderTableWithSubdimensions } from '@features/lci-report/subdomains/visitation/slides/appendix/dimension-tables/components/render-table';
import { rslDimensionsTableSlide } from '../../../rsl-dimensions-table-slide';

const SUBDIMENSIONS_PER_SLIDE = 8;

type SalesAttributionTableSlidesProps = {
  overallSalesMetrics: NonNullable<Lci3Report['salesMetrics']>;
  dimensionTableData: Lci3DimensionTableData;
  overallReport: Pick<RslReport, 'impressions' | 'uniqueUsers'>;
  customFields: CustomFields;
};

export const salesAttributionTableSlides = ({
  overallSalesMetrics,
  dimensionTableData,
  overallReport,
  customFields,
}: SalesAttributionTableSlidesProps): Slide[] =>
  renderTableWithSubdimensions(
    dimensionTableData,
    SUBDIMENSIONS_PER_SLIDE,
    ({ subdimensions, dimensionName, dimensionSlug, page, totalPages }) => {
      const customField =
        customFields.dimensions[
          dimensionSlug as keyof CustomFields['dimensions']
        ];
      const slideHeader =
        customField && customField.salesTableHeader.length > 0
          ? customField.salesTableHeader
          : `Sales Attribution Summary Table - By ${dimensionName} (${page}/${totalPages})`;

      return rslDimensionsTableSlide({
        slideMaster: DEFAULT_SLIDE_MASTER,
        subdimensions,
        overallSalesMetrics,
        slideHeader,
        overallReport,
      });
    }
  );
